<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Grievance Redressal Committee</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

    <section class="section-lg std-scholarship">
        <div class="container">
            <div class="table-responsive" >
                <table class="table table-bordered text-center tbl_custom">
                    <thead>
                        <tr>
                            
                        <th>Sr. No.</th>
                        <th>Name</th>
                        <th>Designation</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                       
                        <tr>
                            <td>1</td>
                            <td>Dr. Jasvinder Kaur</td>
                            <td>Chairperson</td>
                            
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Ms. Madhuri Barua</td>
                            <td>Senior Faculty Member</td>
                           
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Ms. Pragati Ramteke</td>
                            <td>Faculty Member</td>
                           
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Ms. Madhuri Kale</td>
                            <td>Faculty Member</td>
                            
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>Ms Sajeda Khatun</td>
                            <td>Student Representative</td>
                           
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>Ms Anushree thakur</td>
                            <td>Student Representative</td>
                           
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        </div>
    </section>